import React from 'react';
import IconArrowUp from 'cccisd-icons/arrow-up8';
import IconArrowDown from 'cccisd-icons/arrow-down7';
import style from './style.css';

const BySession = props => {
    const { highestFidelitySession, lowestFidelitySession } = props.data;
    const { colors } = props;
    return (
        <div className={style.wrapper}>
            <div
                className={style.left}
                style={
                    colors
                        ? {
                              borderRight: `1px solid ${colors.primary}`,
                          }
                        : {}
                }
            >
                <div
                    className={style.heading}
                    style={
                        colors
                            ? {
                                  color: colors.primary,
                              }
                            : {}
                    }
                >
                    <IconArrowUp spaceRight />
                    Highest Fidelity
                </div>
                <div className={style.content}>
                    <div
                        className={style.mediumFont}
                        style={
                            colors
                                ? {
                                      color: colors.primary,
                                  }
                                : {}
                        }
                    >
                        Session
                    </div>
                    <div
                        className={style.bigFont}
                        style={
                            colors
                                ? {
                                      color: colors.primary,
                                  }
                                : {}
                        }
                    >
                        {highestFidelitySession}
                    </div>
                </div>
            </div>
            <div className={style.right}>
                <div
                    className={style.heading}
                    style={
                        colors
                            ? {
                                  color: colors.primary,
                              }
                            : {}
                    }
                >
                    <IconArrowDown spaceRight />
                    Lowest Fidelity
                </div>
                <div className={style.content}>
                    <div
                        className={style.mediumFont}
                        style={
                            colors
                                ? {
                                      color: colors.primary,
                                  }
                                : {}
                        }
                    >
                        Session
                    </div>
                    <div
                        className={style.bigFont}
                        style={
                            colors
                                ? {
                                      color: colors.primary,
                                  }
                                : {}
                        }
                    >
                        {lowestFidelitySession}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BySession;
